import { MoodEntry, User, Achievement, Challenge } from '../types'
import { initializeAchievements, initializeChallenges } from './gamification'

const MOOD_ENTRIES_KEY = 'mood-tracker-entries'
const USER_KEY = 'mood-tracker-user'
const ACHIEVEMENTS_KEY = 'mood-tracker-achievements'
const CHALLENGES_KEY = 'mood-tracker-challenges'

export const saveMoodEntry = (entry: MoodEntry): void => {
  const entries = getMoodEntries()
  entries.push(entry)
  localStorage.setItem(MOOD_ENTRIES_KEY, JSON.stringify(entries))
}

export const getMoodEntries = (): MoodEntry[] => {
  try {
    const entries = localStorage.getItem(MOOD_ENTRIES_KEY)
    return entries ? JSON.parse(entries) : []
  } catch (error) {
    console.error('Error loading mood entries:', error)
    return []
  }
}

export const saveUser = (user: User): void => {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export const getUser = (): User | null => {
  try {
    const user = localStorage.getItem(USER_KEY)
    return user ? JSON.parse(user) : null
  } catch (error) {
    console.error('Error loading user:', error)
    return null
  }
}

export const getAchievements = (): Achievement[] => {
  try {
    const achievements = localStorage.getItem(ACHIEVEMENTS_KEY)
    if (achievements) {
      return JSON.parse(achievements)
    } else {
      // Initialize achievements for first time users
      const initialAchievements = initializeAchievements()
      localStorage.setItem(ACHIEVEMENTS_KEY, JSON.stringify(initialAchievements))
      return initialAchievements
    }
  } catch (error) {
    console.error('Error loading achievements:', error)
    return initializeAchievements()
  }
}

export const saveAchievement = (achievement: Achievement): void => {
  const achievements = getAchievements()
  const index = achievements.findIndex(a => a.id === achievement.id)
  if (index !== -1) {
    achievements[index] = achievement
    localStorage.setItem(ACHIEVEMENTS_KEY, JSON.stringify(achievements))
  }
}

export const getChallenges = (): Challenge[] => {
  try {
    const challenges = localStorage.getItem(CHALLENGES_KEY)
    if (challenges) {
      return JSON.parse(challenges)
    } else {
      // Initialize challenges for first time users
      const initialChallenges = initializeChallenges()
      localStorage.setItem(CHALLENGES_KEY, JSON.stringify(initialChallenges))
      return initialChallenges
    }
  } catch (error) {
    console.error('Error loading challenges:', error)
    return initializeChallenges()
  }
}

export const saveChallenge = (challenge: Challenge): void => {
  const challenges = getChallenges()
  const index = challenges.findIndex(c => c.id === challenge.id)
  if (index !== -1) {
    challenges[index] = challenge
    localStorage.setItem(CHALLENGES_KEY, JSON.stringify(challenges))
  }
}

export const clearAllData = (): void => {
  localStorage.removeItem(MOOD_ENTRIES_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(ACHIEVEMENTS_KEY)
  localStorage.removeItem(CHALLENGES_KEY)
}